const DEPARTURE_HEADER_CELL = ['ui.schedule.departure', 'ui.schedule.to', 'ui.schedule.airline', 'ui.schedule.router', 'ui.schedule.area', 'ui.schedule.gate', 'ui.schedule.status', 'ui.schedule.status-update', 'ui.schedule.delayed'];
const ARRIVAL_HEADER_CELL = ['ui.schedule.arrival', 'ui.schedule.from', 'ui.schedule.airline', 'ui.schedule.router', 'ui.schedule.area', 'ui.schedule.gate', 'ui.schedule.status', 'ui.schedule.status-update', 'ui.schedule.delayed'];

export {
    DEPARTURE_HEADER_CELL,
    ARRIVAL_HEADER_CELL
};
